// extracted by mini-css-extract-plugin
module.exports = {"Content":"ProductContent_Content__jNN0c","ButtonWrap":"ProductContent_ButtonWrap__1oCAv"};